import * as domainConstants from "../../constants/DomainConstants";
import * as ajax from "../../actions/ajaxCounterActions";
import showToastr from "../../util/toastr.js";
import { showToastrInfo, showToastrError, showToastrSuccess } from "../../util/toastr.js";
import redirector from "../../util/redirector.js";
import { getStore } from "../../store/configureStore";

export default class IndienenPageHelper {
    constructor(context, redirector) {
        this.dispatch = getStore().dispatch;
        this.context = context;
        this.redirector = redirector;
    }

    handleFileRequest(component, actionParam, fileProcess) {
        if (!this.context.state.fileSessionStarted) {
            this.context.props.startFileSession(this.context.props.indienen.dossierId, domainConstants.DocumentTab.Indienen)
                .then(result => {
                    if (!result.success) {
                        showToastrError("Verwerken van bestand is mislukt");
                        throw new Error("File process failed");
                    } else {
                        this.context.setState({
                            fileSessionStarted: true
                        });
                    }
                }).then(() => fileProcess(component, actionParam));
        }
        else
            fileProcess(component, actionParam);
    }

    init() {
        const dossierId = this.context.props.params.dossierId;
        this.context.props.loadIndienen(dossierId)
            .then(isIngediend => {
                if (isIngediend)
                    redirector.goTo("/indienen/bevestiging");
            });

        this.context.props.getContent(dossierId, "dossierPDF")
            .then(result => {
                if (result.success) {
                    const pdfFiles = result.data.length > 0 && result.data[1].files.length > 0 ? result.data[1] : null;
                    if (pdfFiles) {
                        this.context.setState(
                            {
                                pdf: pdfFiles
                            });
                    }
                }
            });

        this.context.props.getContent(dossierId, domainConstants.DocumentTab.Indienen)
            .then(result => {
                if (result.success) {
                    this.context.setState(
                        {
                            documenten: result.data
                        });
                }
            });
    }

    unmount() {
        if (this.context.state.timer) {
            clearInterval(this.context.state.timer);
        }
    }

    update(nextProps) {
        if (this.context.props.indienen !== nextProps.indienen) {
            const dossierId = this.context.props.params.dossierId;
            const indienen = nextProps.indienen;
            this.context.props.loadLayout(dossierId, indienen.dossierNaam, indienen.tabTitle, indienen.initialisatieOK, indienen.typeDossier, nextProps.infrastructuurId, indienen.redenVanStatus && (indienen.redenVanStatus.toString() != domainConstants.REDEN_VAN_STATUS_INGEDIEND.toString()));
        }
    }

    onDienIn(event) {
        event.preventDefault();

        if (this.context.state.fileSessionStarted) {
            showToastrInfo("Verwerken van bestanden. Even geduld");

            this.context.props.endFileSession(this.context.props.indienen.dossierId, domainConstants.DocumentTab.Indienen)
                .then(result => {
                    if (!result.success) {
                        showToastrError(domainConstants.HAS_FILE_EXCEPTION);
                        throw new Error("File process failed");
                    } else {
                        this.context.setState({ fileSessionStarted: false });
                    }
                });
        }

        this.context.props.confirmIndienen(this.context.props.indienen.dossierId)
            .then(isIngediend => {
                if (isIngediend) {
                    redirector.goTo("/indienen/bevestiging");
                }
            });
    }

    handleOnStartInterval() {
        this.context.setState({ pollCount: 0 });

        const timer = setInterval(() => {
            if (this.context.state.pollCount > 29) {
                this.handleOnStopInterval();
            }

            this.context.props.getContent(this.context.props.indienen.dossierId, "dossierPDF")
                .then(result => {
                    if (result.success) {
                        const pdfFiles = result.data.length > 0 && result.data[1].files.length > 0 ? result.data[1] : null;
                        if (pdfFiles) {
                            this.context.setState({ pdf: pdfFiles });
                            this.handleOnStopInterval();
                        }
                    }
                    this.context.setState({ pollCount: this.context.state.pollCount + 1 });
                });
        }, 2000);

        this.context.setState({ timer: timer });
    }

    handleOnStopInterval() {
        clearInterval(this.context.state.timer);
        this.context.setState({ timer: null });
        this.dispatch(ajax.ended());
    }

    onGeneratePdf() {
        this.dispatch(ajax.started());

        this.context.props.generatePdf(this.context.props.params.dossierId)
            .then(success => {
                if (!success) {
                    showToastrError("Genereren van PDF mislukt.");
                    return;
                }

                this.handleOnStartInterval();
            });
    }
}
